import { axiosRequest } from '@/util/axios-request';
// const method = 'get'
var listUrl = '/web/approval/list';
var exportUrl = '/web/approval/exportList';
var seeUrl = '/web/approval/detail';
var configUrl = '/web/approval/getInfo';
var eSUrl = '/web/approval/exportMore';
var typeUrl = '/web/approval/getBuildInTypes';

// 表格
export var listFn = function listFn(data) {
  return axiosRequest({
    url: listUrl,
    data: data
  });
};

// 导出
export var exportFn = function exportFn(params) {
  return axiosRequest({
    url: exportUrl,
    data: params
  });
};

// 查看
export var seeFn = function seeFn(data) {
  return axiosRequest({
    url: seeUrl,
    data: data
  });
};

// 获取配置
export var configFn = function configFn() {
  return axiosRequest({
    url: configUrl
  });
};
export var exportMore = function exportMore(data) {
  return axiosRequest({
    url: eSUrl,
    data: data
  });
};

// 获取时间类型枚举
export var getBuildInTypes = function getBuildInTypes(data) {
  return axiosRequest({
    url: typeUrl
  });
};